module.exports = __webpack_public_path__ + "img/errorImg.3b069979.jpg";